import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PAINEL_OFICINA_BASE } from '@/lib/painelOficina';

/** `/dashboard-oficina/lista` foi descontinuado; preserva query (ex.: companyId). */
export const DashboardOficinaListaRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: PAINEL_OFICINA_BASE, search }} replace />;
};
